// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    background-color:var(--main-very-light-hg-color);
}

.indicContainer {
    width: 80%;
    display: block !important;
    background-color: var(--main-very-light-hg-color);
    text-align: center;
}

.veryBasicContainer {
    display: inline-block;
    height: 300px;
    width: 17%;
}

.active {
    font-weight: bold !important;
    background-color: var(--main-hg-color);
    color: white !important;
  }

  @media (max-width: 768px) {
    .indicContainer {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mainpage.css"],"names":[],"mappings":"AAAA;IACI,gDAAgD;AACpD;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,uBAAuB;EACzB;;EAEA;IACE;QACI,WAAW;IACf;AACJ","sourcesContent":["#root {\n    background-color:var(--main-very-light-hg-color);\n}\n\n.indicContainer {\n    width: 80%;\n    display: block !important;\n    background-color: var(--main-very-light-hg-color);\n    text-align: center;\n}\n\n.veryBasicContainer {\n    display: inline-block;\n    height: 300px;\n    width: 17%;\n}\n\n.active {\n    font-weight: bold !important;\n    background-color: var(--main-hg-color);\n    color: white !important;\n  }\n\n  @media (max-width: 768px) {\n    .indicContainer {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
